<script lang="ts" setup>
// Change layout template
import { useCookie } from "#app";
import LoginForm from "~/components/account/LoginForm.vue";

definePageMeta({
    middleware: "guest",
    layout: "blank",
});

const state = useCookie("userState").value;
const link = "/home/" + (state ? state : "ga");
</script>

<template>
    <div class="flex min-h-screen flex-col items-center sm:justify-center">
        <NuxtLink :to="link">
            <img src="/images/ABC_logo_224x160.png" class="h-36" alt="ABC Logo" />
        </NuxtLink>

        <div class="mt-4 w-full border shadow-xl sm:max-w-md sm:rounded-lg">
            <LoginForm />
        </div>
    </div>
</template>

<style scoped></style>
